import { Block } from 'slate';
import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function getCellCoords(editor, cell, table) {
  var tableCells;

  if (Block.isBlock(table)) {
    tableCells = table.nodes;
  } else {
    var tableId = cell.getIn(['data', 'tableId']);
    tableCells = editor.getTableCells(tableId);
  }

  var tableColumnCount = getTableColumnCountForCells(tableCells);
  var cellIndex = tableCells.findIndex(function (c) {
    return c.key === cell.key;
  });
  return [Math.floor(cellIndex / tableColumnCount), cellIndex % tableColumnCount];
}